<template>
    <div>
        <h2 class="text-lg-h5 font-weight-bold mb-6">Einstellungen</h2>
        <v-tabs class="borderTopRadius" v-model="tabIndex" :color="ada.blue" show-arrows>
            <v-tabs-slider :color="ada.blue"></v-tabs-slider>
            <v-tab v-model="tabIndex" flat v-for="tab in tabs" :key="tab.name">
                {{ tab.name }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabIndex" ref="tabContent" class="borderBottomRadius">
            <v-tab-item
                v-for="tab in tabs"
                :key="tab.name+'_i'"
            >
                <v-card flat>
                    <v-card-text style="min-height: 20vh;">
                        <transition name="fade" mode="out-in">
                            <component :is="tab.component"
                                       @click="openDialog"
                            />
                        </transition>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import ada from "../../scss/ada_colors.scss";
import Settings_Size from "./Tabs/Settings_Size";
import Settings_Module from "./Tabs/Settings_Module";
import Settings_Position from "./Tabs/Settings_Position";
import Settings_Publisher from "./Tabs/Settings_Publisher";
import Settings_Sites from "./Tabs/Settings_Sites";
import Settings_Targetings from "./Tabs/Settings_Targetings";

export default {
    name: "Settings",
    components: {
        Settings_Targetings,
        Settings_Sites, Settings_Publisher, Settings_Position, Settings_Module, Settings_Size
    },
    data: () => {
        return {
            tabIndex: null,
            tabs: [
                {name: 'Sites', component: 'Settings_Sites'},
                {name: 'Size', component: 'Settings_Size', fetchDetails: 'fetchSizeDetails'},
                {name: 'Position', component: 'Settings_Position', fetchDetails: 'fetchPositionsDetails'},
                {name: 'Module', component: 'Settings_Module', fetchDetails: 'fetchModuleDetails'},
                {name: 'Publisher', component: 'Settings_Publisher', fetchDetails: 'fetchPublisherDetails'},
                {name: 'Targetings', component: 'Settings_Targetings', fetchDetails: null},
            ],
            ada
        }
    },
    mounted() {
        this.$store.dispatch('settings/fetchConfig');
        this.$store.dispatch('settings/fetchGeneralTargetingList');
        this.$store.commit('settings/updateActiveTab', this.tabs[this.tabIndex].component);
    },
    computed: {
        role() {
            return this.$store.state.users.role;
        }
    },
    methods: {
        async fetchDetails(type) {
            await this.$store.dispatch(type);
        },
        async openDialog(item, deleting, component) {
            await this.$store.dispatch('settings/updateSelected', {
                item: item,
                fetchDetails: this.tabs.find(x => x.component === component.$options._componentTag).fetchDetails
            });
            if (deleting) {
                component.showDeleteDialog = true;
            } else {
                component.showDialog = true;
            }
        }
    },
    watch: {
        tabIndex() {
            this.$store.commit('settings/updateActiveTab', this.tabs[this.tabIndex].component);
        }
    }
}
</script>

<style scoped>

</style>